import React from 'react';

function MobileWelcome({ onGetStarted, onLogin }) {
  return (
    <div
      className="relative w-full h-[100dvh] flex flex-col justify-between items-center overflow-hidden px-6 py-6 select-none"
      style={{
        fontFamily: "'Poppins', 'Inter', sans-serif",
        maxWidth: '430px',
        margin: '0 auto',
        background: 'linear-gradient(180deg, #f8f9fe 0%, #f1f3fd 50%, #eaeefc 100%)',
      }}
    >
      {/* BACKGROUND DECORATION */}
      {/* Top Left Dot Grid */}
      <div className="absolute top-6 left-6 grid grid-cols-4 gap-1.5 opacity-20 pointer-events-none z-0">
        {[...Array(16)].map((_, i) => (
          <div key={i} className="w-1 h-1 rounded-full bg-slate-500" />
        ))}
      </div>

      {/* Middle Right Dot Grid */}
      <div className="absolute top-[52%] right-6 grid grid-cols-4 gap-1.5 opacity-20 pointer-events-none z-0">
        {[...Array(16)].map((_, i) => (
          <div key={i} className="w-1 h-1 rounded-full bg-slate-500" />
        ))}
      </div>

      {/* Bottom Subtle Gradient Waves */}
      <div className="absolute bottom-20 left-0 right-0 h-48 opacity-30 pointer-events-none z-0">
        <svg viewBox="0 0 500 150" preserveAspectRatio="none" className="w-full h-full">
          <path d="M0,80 C150,140 350,-20 500,80 L500,150 L0,150 Z" fill="url(#waveGrad)" />
          <defs>
            <linearGradient id="waveGrad" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#c084fc" stopOpacity="0.4" />
              <stop offset="100%" stopColor="#60a5fa" stopOpacity="0.4" />
            </linearGradient>
          </defs>
        </svg>
      </div>

      {/* MAIN HERO SECTION */}
      <div className="relative z-10 w-full flex flex-col items-center justify-center my-auto pt-2">
        
        {/* SVG Logo Vector */}
        <div className="w-full max-w-[120px] mb-2 flex justify-center">
          <svg
            viewBox="216 265 667 510"
            className="w-full h-auto"
            style={{ filter: 'drop-shadow(0 8px 16px rgba(90,60,180,0.18))' }}
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <linearGradient
                id="iconGrad"
                gradientUnits="userSpaceOnUse"
                x1="216"
                y1="0"
                x2="883"
                y2="0"
              >
                <stop offset="0%" stopColor="#0a3fe0" />
                <stop offset="15%" stopColor="#1448e1" />
                <stop offset="30%" stopColor="#3a54da" />
                <stop offset="45%" stopColor="#7233bb" />
                <stop offset="60%" stopColor="#a42ea3" />
                <stop offset="75%" stopColor="#c32f94" />
                <stop offset="90%" stopColor="#da3189" />
                <stop offset="100%" stopColor="#e2368c" />
              </linearGradient>

              <radialGradient id="shadowGrad" cx="50%" cy="50%" r="50%">
                <stop offset="0%" stopColor="#a9a6c8" stopOpacity="0.3" />
                <stop offset="100%" stopColor="#a9a6c8" stopOpacity="0" />
              </radialGradient>
            </defs>

            <ellipse
              cx="549"
              cy="800"
              rx="240"
              ry="18"
              fill="url(#shadowGrad)"
            />

            <path
              fill="url(#iconGrad)"
              fillRule="evenodd"
              d="M 496.00,344.00 C 495.10,340.80 481.87,333.69 479.00,332.00 C 476.13,330.31 454.79,319.09 450.00,317.00 C 445.21,314.91 421.08,306.25 417.00,305.00 C 412.92,303.75 394.81,299.69 391.00,299.00 C 387.19,298.31 370.86,296.21 367.00,296.00 C 363.14,295.79 336.07,295.92 335.00,296.00 C 333.93,296.08 329.80,298.36 329.00,299.00 C 328.20,299.64 325.48,303.11 325.00,304.00 C 324.52,304.89 323.01,308.99 323.00,310.00 C 322.99,311.01 323.00,478.77 323.00,479.00 C 323.00,479.23 323.77,479.99 324.00,480.00 C 324.23,480.01 349.77,480.01 350.00,480.00 C 350.23,479.99 351.00,479.23 351.00,479.00 C 351.00,478.77 350.99,328.68 351.00,328.00 C 351.01,327.32 353.33,325.11 354.00,325.00 C 354.67,324.89 366.61,324.80 369.00,325.00 C 371.39,325.20 386.69,327.26 390.00,328.00 C 393.31,328.74 417.84,335.17 423.00,337.00 C 428.16,338.83 451.85,349.45 455.00,351.00 C 458.15,352.55 471.68,360.52 474.00,362.00 C 476.32,363.48 487.69,371.82 488.00,372.00 C 488.31,372.18 489.90,371.34 490.00,371.00 C 490.10,370.66 496.90,347.20 496.00,344.00 Z M 263.00,361.00 C 262.36,403.88 261.64,452.12 261.00,495.00 C 248.20,496.60 233.80,498.40 221.00,500.00 C 221.00,507.36 221.00,515.64 221.00,523.00 C 282.12,523.96 402.75,528.01 412.00,526.00 C 421.25,523.99 432.40,491.32 442.00,475.00 C 454.16,504.12 467.84,536.88 480.00,566.00 C 486.08,562.48 497.98,558.36 499.00,555.00 C 500.02,551.64 524.84,434.64 537.00,378.00 C 550.12,454.48 564.88,540.52 578.00,617.00 C 584.40,614.12 596.77,611.29 598.00,608.00 C 599.23,604.71 621.12,516.20 632.00,473.00 C 638.40,480.36 647.12,495.96 652.00,496.00 C 656.88,496.04 729.31,473.85 741.00,474.00 C 752.69,474.15 806.38,486.88 810.00,498.00 C 813.62,509.12 808.64,621.76 808.00,680.00 C 774.08,679.68 718.73,676.21 702.00,679.00 C 685.27,681.79 623.12,704.84 586.00,717.00 C 609.36,700.04 645.77,669.77 659.00,664.00 C 672.23,658.23 762.43,650.04 774.00,635.00 C 785.57,619.96 776.84,516.38 776.00,512.00 C 775.16,507.62 757.64,507.24 749.00,505.00 C 748.36,539.24 758.17,599.02 747.00,612.00 C 735.83,624.98 640.37,640.49 626.00,648.00 C 611.63,655.51 574.32,693.56 550.00,715.00 C 523.44,692.60 482.44,652.96 467.00,645.00 C 451.56,637.04 362.45,621.36 354.00,614.00 C 345.55,606.64 351.96,566.40 351.00,544.00 C 342.04,544.00 331.96,544.00 323.00,544.00 C 325.24,574.72 319.20,629.02 330.00,640.00 C 340.80,650.98 429.15,659.39 442.00,665.00 C 454.85,670.61 488.92,701.72 511.00,719.00 C 476.44,706.52 420.66,683.05 403.00,680.00 C 385.34,676.95 326.84,680.68 291.00,681.00 C 290.36,637.16 289.64,587.84 289.00,544.00 C 280.36,543.68 270.64,543.32 262.00,543.00 C 263.60,596.12 265.40,655.88 267.00,709.00 C 315.00,709.96 393.59,706.69 417.00,712.00 C 440.41,717.31 537.67,774.76 558.00,775.00 C 578.33,775.24 650.29,719.96 670.00,715.00 C 689.71,710.04 782.88,708.20 836.00,705.00 C 836.96,638.76 838.04,564.24 839.00,498.00 C 849.88,497.36 870.00,497.36 873.00,496.00 C 876.00,494.64 879.80,483.76 883.00,478.00 C 844.60,470.64 801.40,462.36 763.00,455.00 C 788.60,424.60 839.37,366.40 843.00,360.00 C 846.63,353.60 845.19,320.33 843.00,314.00 C 840.81,307.67 821.85,285.26 816.00,282.00 C 810.15,278.74 779.30,274.03 773.00,275.00 C 766.70,275.97 744.37,294.08 738.00,294.00 C 731.63,293.92 697.15,273.65 689.00,274.00 C 680.85,274.35 647.75,294.44 644.00,298.00 C 640.25,301.56 632.55,322.86 632.00,328.00 C 631.45,333.14 633.97,359.04 637.00,364.00 C 640.03,368.96 680.52,416.36 701.00,441.00 C 708.36,435.56 716.64,429.44 724.00,424.00 C 704.16,400.64 664.82,357.35 662.00,351.00 C 659.18,344.65 669.95,312.59 673.00,309.00 C 676.05,305.41 697.58,302.38 702.00,304.00 C 706.42,305.62 728.52,324.40 741.00,334.00 C 750.60,325.04 767.63,307.87 771.00,306.00 C 774.37,304.13 791.31,302.88 795.00,304.00 C 798.69,305.12 812.11,315.62 814.00,319.00 C 815.89,322.38 819.54,341.08 818.00,345.00 C 816.46,348.92 791.53,386.35 785.00,393.00 C 778.47,399.65 708.37,458.67 703.00,462.00 C 697.63,465.33 669.54,471.03 664.00,468.00 C 658.46,464.97 641.31,429.36 639.00,427.00 C 636.69,424.64 625.40,423.60 619.00,422.00 C 609.08,454.96 597.92,492.04 588.00,525.00 C 574.88,444.04 560.12,352.96 547.00,272.00 C 539.64,275.20 525.13,278.15 524.00,282.00 C 522.87,285.85 494.76,427.52 481.00,496.00 C 473.32,474.56 458.64,431.86 457.00,429.00 C 455.36,426.14 444.08,423.56 438.00,421.00 C 425.84,445.32 412.08,490.76 400.00,497.00 C 387.92,503.24 325.88,497.00 291.00,497.00 C 290.36,461.48 288.64,388.77 289.00,386.00 C 289.36,383.23 304.62,384.43 306.00,382.00 C 307.38,379.57 306.00,364.32 306.00,356.00 C 292.24,357.60 276.76,359.40 263.00,361.00 Z"
            />
          </svg>
        </div>

        {/* App Title */}
        <h1 className="text-center font-extrabold text-[#091540] text-3xl sm:text-4xl leading-none">
          My Health
        </h1>
        <h1
          className="text-center font-extrabold text-3xl sm:text-4xl leading-tight"
          style={{
            backgroundImage:
              'linear-gradient(90deg, #d92b7c 0%, #7e38ba 50%, #463cd5 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}
        >
          Journal
        </h1>

        {/* Heartbeat Pulse Line Divider */}
        <div className="flex items-center gap-2 my-2.5 opacity-40 w-full max-w-[180px]">
          <div className="h-[1px] bg-[#3956df] flex-1" />
          <svg className="w-5 h-3 text-[#3956df]" viewBox="0 0 24 12" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M0,6 L6,6 L8,1 L11,11 L14,3 L16,8 L18,6 L24,6" />
          </svg>
          <div className="h-[1px] bg-[#3956df] flex-1" />
        </div>

        {/* Tagline */}
        <p className="text-[#3956df] text-[10px] sm:text-[11px] font-extrabold tracking-[0.2em] uppercase">
          Your Health, Your Journey
        </p>

        {/* FEATURE HIGHLIGHTS GRID */}
        <div className="grid grid-cols-3 gap-2 w-full max-w-[340px] mt-8 pt-2">
          {/* Feature 1 */}
          <div className="flex flex-col items-center text-center">
            <div className="w-10 h-10 rounded-full bg-[#3b82f6]/10 flex items-center justify-center text-[#2563eb] mb-2 shadow-2xs">
              <span className="material-symbols-outlined text-lg">security</span>
            </div>
            <p className="text-[11px] font-bold text-[#0f172a] leading-tight">
              Secure &<br />Private
            </p>
          </div>

          {/* Vertical Divider 1 */}
          <div className="relative flex flex-col items-center text-center">
            <div className="absolute left-0 top-2 bottom-2 w-[1px] bg-slate-200/80" />
            <div className="w-10 h-10 rounded-full bg-[#a855f7]/10 flex items-center justify-center text-[#9333ea] mb-2 shadow-2xs">
              <span className="material-symbols-outlined text-lg">assignment</span>
            </div>
            <p className="text-[11px] font-bold text-[#0f172a] leading-tight">
              Track Your<br />Health
            </p>
            <div className="absolute right-0 top-2 bottom-2 w-[1px] bg-slate-200/80" />
          </div>

          {/* Feature 3 */}
          <div className="flex flex-col items-center text-center">
            <div className="w-10 h-10 rounded-full bg-[#ec4899]/10 flex items-center justify-center text-[#db2777] mb-2 shadow-2xs">
              <span className="material-symbols-outlined text-lg">group</span>
            </div>
            <p className="text-[11px] font-bold text-[#0f172a] leading-tight">
              Better Care<br />Together
            </p>
          </div>
        </div>

      </div>

      {/* BOTTOM ACTION AREA */}
      <div className="relative z-10 w-full flex flex-col items-center">
        <div className="w-full max-w-[330px] flex flex-col gap-3">
          
          {/* Primary Action */}
          <button
            onClick={onGetStarted}
            className="w-full py-3.5 px-5 rounded-2xl text-white font-bold text-sm active:scale-[0.98] transition-transform cursor-pointer flex items-center justify-center gap-2 shadow-lg"
            style={{
              background:
                'linear-gradient(90deg, #d92b7c 0%, #633ad6 100%)',
              boxShadow: '0 8px 20px -4px rgba(126, 56, 186, 0.4)',
            }}
          >
            <span>Get Started</span>
            <span className="material-symbols-outlined text-base">arrow_forward</span>
          </button>
          
          {/* Secondary Action */}
          <button
            onClick={onLogin}
            className="w-full py-3 px-5 rounded-2xl font-bold text-sm active:scale-[0.98] transition-transform cursor-pointer bg-white/90 backdrop-blur-xs flex items-center justify-center gap-2 shadow-xs"
            style={{
              border: '1.5px solid #633ad6',
              color: '#633ad6',
            }}
          >
            <span>Log In</span>
            <span className="material-symbols-outlined text-base">arrow_forward</span>
          </button>
        </div>

        {/* Security & HIPAA Compliance Notice */}
        <div className="mt-5 px-4 py-1.5 rounded-xl bg-white/60 border border-slate-200/60 backdrop-blur-xs flex items-center gap-2 max-w-[280px]">
          <div className="w-6 h-6 rounded-lg bg-indigo-50 flex items-center justify-center shrink-0">
            <span className="material-symbols-outlined text-indigo-600 text-xs">lock</span>
          </div>
          <p className="text-[9px] text-slate-500 font-medium leading-tight">
            Your data is encrypted and HIPAA compliant
          </p>
        </div>

        {/* Footer with India Flag */}
        <div className="mt-4 flex items-center gap-2 text-[11px] text-slate-400 font-medium">
          <span>Made in India</span>
          <span className="text-slate-300">•</span>
          <span className="text-base leading-none">🇮🇳</span>
        </div>
      </div>
    </div>
  );
}

export default MobileWelcome;